import { FaHandsHoldingChild } from 'react-icons/fa6';

import type { AuthUser } from '../types/domain';

export const FAMILY_CO_BUILDING_ICON_KEY = 'family_co_building';

export function userHasFamilyCoBuildingIcon(user: Pick<AuthUser, 'accountIcons'> | null | undefined): boolean {
  return Boolean(
    user?.accountIcons?.some(
      (icon) => icon.iconKey === FAMILY_CO_BUILDING_ICON_KEY && icon.status !== 'revoked',
    ),
  );
}

/** Badge for the paid Flo 家庭共建计划 membership on a Psycheflow account. */
export function FamilyCoBuildingPlanBadge({ size = 16 }: { size?: number }) {
  return (
    <span
      className="inline-flex items-center justify-center rounded-full border border-primary/30 bg-primary/10 text-primary"
      style={{ width: size + 8, height: size + 8 }}
      title="家庭共建计划"
      aria-label="家庭共建计划"
    >
      <FaHandsHoldingChild size={size} aria-hidden />
    </span>
  );
}
